<template>
  <div class="ev-page-container">
    <!-- add stadion-tatjana-01 modal -->
    <modal
      name="add-stadion-tatjana-01-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
      @before-close="modalClosed"
    >
      <edit-stadion-tatjana-01
        :selectedItem="selectedItem"
        :selectedDailyLog="selectedDailyLog"
        :isSaveAndProceedButtonVisible="false"
        :statuses="statuses"
        :employees="employeesForEditList"
        :isEmployeesVisible="true"
        :departments="departmentData"
        :isStatusesVisible="true"
        :isDatesVisible="false"
        title="izmjena komentara"
        @saveAndCloseClicked="addItem"
        @saveAndProceedClicked="closeItem"
      />
    </modal>

    <!-- Page Header -->
    <div class="ev-page-header">
      <h1 class="ev-page-title">Pregled mjesečne prisutnosti</h1>
      <p class="ev-page-subtitle">
        Detaljan pregled prisustva za izabranog zaposlenog
      </p>
    </div>

    <!-- Filters Card -->
    <div class="ev-filters-card no-print">
      <div class="ev-filters-grid">
        <!-- Month Picker -->
        <div class="ev-filter-group">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">📅</span>
            Mjesec
          </label>
          <date-picker
            v-model="time3"
            @input="monthChosen"
            type="month"
            class="ev-date-picker"
          ></date-picker>
        </div>

        <!-- Employee Picker -->
        <div class="ev-filter-group">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">👤</span>
            Zaposleni
          </label>
          <vue-select
            class="ev-select"
            @input="employeeSelected"
            type="text"
            label="name"
            :clearable="false"
            :options="employees"
            v-model="selectedEmployee"
            placeholder="Izaberite zaposlenog..."
          >
            <template #option="{ name, status }">
              <span
                :class="{ 'ev-inactive-employee-option': status === false }"
              >
                {{ name }}
              </span>
            </template>
          </vue-select>
        </div>
      </div>
    </div>

    <!-- Table Section -->
    <div class="ev-table-section" v-if="selectedEmployee">
      <div class="ev-table-header">
        <h3 class="ev-table-title">
          <span class="ev-badge-light">{{ selectedEmployee.name }}</span>
          <span class="ev-badge-light month-badge"
            >{{ getMonthName(selectedMonth) }} {{ selectedYear }}</span
          >
        </h3>
      </div>
      <div class="ev-table-container">
        <vue-table-dynamic
          :params="params"
          @cell-click="tableCellClicked"
          @cell-contextmenu="cm"
        >
          <template v-slot:column-6="{ props }">
            <span
              :style="{
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            >
          </template>
          <template v-slot:column-7="{ props }">
            <span
              :style="{
                color: props.cellData.color,
                'text-decoration': props.cellData.decoration,
                cursor: props.cellData.cursor,
              }"
              >{{ props.cellData.value }}</span
            >
          </template>
        </vue-table-dynamic>
      </div>
    </div>

    <!-- Empty State -->
    <div class="ev-empty-state" v-else>
      <div class="ev-empty-icon">📊</div>
      <h3>Izaberite zaposlenog</h3>
      <p>
        Odaberite zaposlenog iz liste iznad da biste vidjeli mjesečni pregled
        prisutnosti.
      </p>
    </div>

    <!-- Context Menu -->
    <context-menu :display="showContextMenu" ref="menu">
      <ul class="ev-context-menu-list">
        <li @click="cmCommentClicked" class="ev-context-menu-item">
          <span class="ev-context-icon">✏️</span>
          Komentar
        </li>
        <li
          @click="cmViewDetails"
          class="ev-context-menu-item ev-context-menu-item--success"
        >
          <span class="ev-context-icon">🔍</span>
          Vidi detalje...
        </li>
      </ul>
    </context-menu>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import specialreportService from "../../services/specialreport.service";
import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import ContextMenu from "../parts/ContextMenu.vue";
import EditStadionTatjana01 from "../parts/EditStadionTatjana01.vue";
import {
  getDateFromTicks,
  maskIfEquealsValue,
  isWorkingDayFromDate,
  getStatusCodeFromStatusId,
  addDays,
  getLateHoursFromTicks,
  getReport01TitlePropertyFromStatusId,
  getReport01recursivePropertyFromStatusId,
  getDepartmentFromEmployeeId,
} from "../../_helpers/arrangers";

// import { getDateFromTicks } from "../../_helpers/arrangers";

const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
];

export default {
  name: "MonthlyPresence",
  components: {
    VueTableDynamic,
    DatePicker,
    ContextMenu,
    EditStadionTatjana01,
  },
  data() {
    return {
      tabSelector: 0,
      filterSelector: 0,
      departmentData: null,
      departments: [],
      employees: [],
      dailyLogs: [],
      statuses: [],
      selectedDailyLog: null,
      selectedName: null,
      selectedEmployee: null,
      selectedMonth: 0,
      selectedYear: 0,
      numberOfElementsThatNeedToBeRecalculated: 0,
      time3: null,
      showContextMenu: false,
      startDate: new Date(),
      endDate: new Date(),
      employeesForEditList: [],
      selectedItem: {
        boldText: "",
        note: "",
        employeeId: null,
        previewString: "",
      },
      params: {
        data: [
          [
            "RB",
            "Datum",
            "RD",
            "Dolazak",
            "Kašnjenje",
            "Odlazak",
            "Izlasci",
            "Odmor/Doručak",
            "Radni sati",
            "Razlika",
            "Status",
            "Komentar",
          ],
        ],
        header: "row",
        enableSearch: false,
        border: true,
        stripe: true,
        wordWrap: "break-word",
        whiteSpace: "normal",
        columnWidth: [
          { column: 0, width: "5%" },
          { column: 1, width: 150 },
          { column: 2, width: 60 },
        ],
      },
    };
  },
  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
    this.getDepartments();
    this.getStatuses();
  },
  methods: {
    // Helper method for month names
    getMonthName(month) {
      const months = [
        "Januar",
        "Februar",
        "Mart",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "August",
        "Septembar",
        "Oktobar",
        "Novembar",
        "Decembar",
      ];
      return months[month - 1] || "";
    },
    // Context menu methods
    openContextMenu(e) {
      this.$refs.menu.open(e);
    },
    cm(params, row) {
      // Get the daily log for this row (row 0 is header, so row-1 for dailyLogs)
      if (row > 0 && row <= this.dailyLogs.length) {
        this.selectedDailyLog = this.dailyLogs[row - 1];

        // Set the start date from the daily log
        this.startDate = new Date(this.selectedDailyLog.logDate);
        this.startDate.setHours(0, 0, 0, 0);
        this.endDate = addDays(this.startDate, 1);

        console.log(
          "Context menu - selected daily log:",
          this.selectedDailyLog
        );
        console.log("Context menu - start date:", this.startDate);

        this.openContextMenu(params);
      }
    },
    cmCommentClicked() {
      console.log("Comment clicked");
      console.log(this.selectedDailyLog);
      console.log(this.selectedEmployee);

      this.employeesForEditList = [];
      this.selectedItem.employeeId = this.selectedEmployee.id;
      this.selectedItem.note = ""; // Reset note field

      this.employeesForEditList.push({
        id: this.selectedEmployee.id,
        name: this.selectedEmployee.name,
        departmentName: getDepartmentFromEmployeeId(
          this.$store.state.general.departmentData,
          this.selectedEmployee.id
        ),
      });

      this.$refs.menu.close();
      this.$modal.show("add-stadion-tatjana-01-modal");
    },
    cmViewDetails() {
      console.log("View details clicked");
      console.log(this.selectedDailyLog);
      console.log(this.selectedEmployee);

      const theDate = new Date(
        this.startDate.getTime() - this.startDate.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];

      this.$refs.menu.close();
      this.$router.push(
        "/user/ManualFix?date=" +
          theDate +
          "&employeeId=" +
          this.selectedEmployee.id
      );
    },
    modalClosed() {},
    addItem(item) {
      this.$modal.hide("add-stadion-tatjana-01-modal");
      console.log("xxItemxx");
      console.log(item);

      let statusId = item.statusId;
      let i = getReport01TitlePropertyFromStatusId(item.statusId);
      let employeeId = item.employeeId;
      let employeeName = this.$store.state.general.employees.find(
        (e) => e.id === employeeId
      ).name;
      let recursive = getReport01recursivePropertyFromStatusId(statusId);

      let data = {
        boldText: employeeName,
        note: item.note,
        userReportId: 2,
        isConfirmed: true,
        employeeId: item.employeeId,
        statusId: statusId,
        sRecursive: recursive,
      };

      console.log("Sending comment:", data);
      console.log("Start date:", this.startDate);

      specialreportService
        .PostDailyReport01(data, this.startDate, i)
        .then((rsp) => {
          console.log(rsp);
          ReportService.GetNormalizedAccessDataByTimeRange(
            this.startDate,
            this.endDate,
            employeeId,
            null
          ).then(() => {
            // Refresh the data
            this.getData();
          });
        });
    },
    closeItem() {
      this.$modal.hide("add-stadion-tatjana-01-modal");
    },
    tableCellClicked(row_id, column_id, cell_data) {
      if (column_id == 2) {
        // console.log(jedan);
        console.log(column_id);
        console.log(cell_data);
        console.log(this.params.data[row_id]);
      }
      if (column_id == 5) {
        this.selectedDailyLog = this.dailyLogs[row_id - 1];
        this.selectedName = this.params.data[row_id][2];
        this.$modal.show("edit-outside-event-modal");
      }
    },
    monthChosen(mnth) {
      console.log(mnth);
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      console.log(this.selectedMonth);
      console.log(this.selectedYear);
      // Reload data if employee is already selected
      if (this.selectedEmployee) {
        this.getData();
      }
    },
    employeeSelected(emp) {
      if (emp) {
        this.getData();
      }
    },
    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        // console.log(response.data);
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
            status: emp.status,
          });
        });
      });
    },
    proba(date) {
      console.log(date);
    },
    resetUi() {
      this.params.data = [
        [
          "RB",
          "Datum",
          "RD",
          "Dolazak",
          "Kašnjenje",
          "Odlazak",
          "Izlasci",
          "Odmor/Doručak",
          "Radni sati",
          "Razlika",
          "Status",
          "Komentar",
        ],
      ];
      this.dailyLogs = [];
    },
    getStatuses() {
      ReportService.GetStatuses().then((response) => {
        this.statuses = response.data;
      });
    },
    recalculateLog(element) {
      if (element.didIstartedYesterday && element.didIstayedTillTomorrow) {
        // rec
        ReportService.GetEarliestPedestrianEntryByEmployeeIdAndDate(
          new Date(element.logDate),
          element.employeeId
        ).then((response) => {
          // arrival time override
          this.dotOrArrow = true;
          element.arrivalTimeGeneral = response.data.accessTime;
          console.log(response.data.accessTime);
          ReportService.GetEarliestPedestrianExitByEmployeeIdAndDate(
            addDays(new Date(element.logDate), 1),
            element.employeeId
          ).then((response) => {
            // departure time override
            element.departureTimeGeneral = response.data.accessTime;
            this.numberOfElementsThatNeedToBeRecalculated--;
            if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
              this.launchPaja();
            }
          });
        });
      } else if (element.didIstartedYesterday) {
        // rec
        ReportService.GetEarliestPedestrianEntryByEmployeeIdAndDate(
          new Date(element.logDate),
          element.employeeId
        ).then((response) => {
          // arrival time override
          this.dotOrArrow = true;
          console.log(response.data.accessTime);
          if (response.data.accessTime === undefined) {
            ReportService.GetLatestPedestrianEntryByEmployeeIdAndDate(
              addDays(new Date(element.logDate), -1),
              element.employeeId
            ).then((response) => {
              //arrival time double override
              this.dotOrArrow = false;
              element.arrivalTimeGeneral = response.data.accessTime;
              this.numberOfElementsThatNeedToBeRecalculated--;
              if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
                this.launchPaja();
              }
            });
          } else {
            element.arrivalTimeGeneral = response.data.accessTime;
            this.numberOfElementsThatNeedToBeRecalculated--;
            if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
              this.launchPaja();
            }
          }
        });
      } else if (element.didIstayedTillTomorrow) {
        ReportService.GetEarliestPedestrianExitByEmployeeIdAndDate(
          addDays(new Date(element.logDate), 1),
          element.employeeId
        ).then((response) => {
          // departure time override
          element.departureTimeGeneral = response.data.accessTime;
          this.numberOfElementsThatNeedToBeRecalculated--;
          if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
            this.launchPaja();
          }
        });
      }
    },

    launchPaja() {
      let ndx = 1;

      // total workhours
      let totalLateThisMonth = 0;
      let totalWorkhoursThisMonth = 0;
      let totalOvertimeThisMonth = 0;

      // populate table
      this.dailyLogs.forEach((element) => {
        totalLateThisMonth += element.lateWorkhours;
        totalWorkhoursThisMonth += element.totalWorkhoursThisDay;
        totalOvertimeThisMonth += element.overtimeWorkhours;
        // izračunaj status
        let statusCode = getStatusCodeFromStatusId(
          element.statusId,
          element.statusIdOverride,
          this.$store.state.general.statuses
        );
        let status = statusCode;
        if (element.logDay === 0 && statusCode.startsWith("SN")) {
          status = "  ";
        }

        // ovo ide tek kasnije, kada se izračuna da je paja 0
        this.params.data.push([
          // "Index"
          ndx++,
          // "Datum",
          new Date(element.logDate).toLocaleDateString("sr-latn-cs", {
            weekday: "short",
          }) +
            ", " +
            new Date(element.logDate).toLocaleDateString("sr-latn-cs"),
          // "Radni dan",
          isWorkingDayFromDate(new Date(element.logDate)) ? "✅" : "❌",
          // "Dolazak",
          this.calculateStartedYesterdayTime(element),
          //"Kašnjenje",
          getLateHoursFromTicks(element),
          // maskIfEquealsValue(
          //   getDateFromTicks(element.lateWorkhours),
          //   "00:00:00"
          // ),
          //"Odlazak",
          this.calculateStayesTillTomorrowTime(element),
          // "Izlasci",
          {
            value: element.outsideEvent.length,
            id: `${1}`,
            color: element.outsideEvent.length > 0 ? colors[1] : colors[0],
            decoration: element.outsideEvent.length > 0 ? "underline" : "none",
            cursor: element.outsideEvent.length > 0 ? "zoom-in" : "default",
          },
          // "Odmor/Doručak",
          {
            value:
              [119, 74, 571].includes(element.employeeId) &&
              element.totalWorkhoursThisDay > 0
                ? "1"
                : element.insideEvent.length,
            id: `${1}`,
            color: element.insideEvent.length > 0 ? colors[1] : colors[0],
            decoration: element.insideEvent.length > 0 ? "underline" : "none",
            cursor: element.insideEvent.length > 0 ? "zoom-in" : "default",
          },
          // "Radni sati"
          maskIfEquealsValue(
            getDateFromTicks(element.totalWorkhoursThisDay),
            "00:00:00"
          ),
          // "Prekovremeno"
          maskIfEquealsValue(
            getDateFromTicks(element.overtimeWorkhours),
            "00:00:00"
          ),
          // "Status",
          [119, 74, 571, 169, 170].includes(element.employeeId) &&
          status.startsWith("SN")
            ? "   "
            : status,
          // "Komentar"
          element.note || "",
        ]);
      });

      // dodajemo sumarni row
      this.params.data.push([
        "",
        "TOTAL:",
        "",
        "",
        maskIfEquealsValue(getDateFromTicks(totalLateThisMonth), "00:00:00"),
        "",
        {
          value: "",
          id: `${1}`,
          color: colors[1],
          decoration: "none",
          cursor: "default",
        },
        {
          value: "",
          id: `${1}`,
          color: colors[1],
          decoration: "none",
          cursor: "default",
        },
        maskIfEquealsValue(
          getDateFromTicks(totalWorkhoursThisMonth),
          "00:00:00"
        ),
        maskIfEquealsValue(
          getDateFromTicks(totalOvertimeThisMonth),
          "00:00:00"
        ),
        "",
        "",
      ]);
    },

    getData() {
      ReportService.GetMonthlyPresenceReviewByEmployeeIdAndMonth(
        this.selectedEmployee.id,
        this.selectedMonth,
        this.selectedYear
      ).then((response) => {
        console.log(response);

        // reset ui
        this.resetUi();

        // recalculate logs
        this.numberOfElementsThatNeedToBeRecalculated = 0;
        let elementsToRecalculate = [];

        // find elements that need to be recalculated
        response.data.forEach((element) => {
          if (element.didIstartedYesterday || element.didIstayedTillTomorrow) {
            this.numberOfElementsThatNeedToBeRecalculated++;
            elementsToRecalculate.push(element);
          }
        });

        // recalculate those elements
        elementsToRecalculate.forEach((etr) => {
          console.log(etr.logDate);
          this.recalculateLog(etr);
        });

        console.log("to recalculate:");
        console.log(this.numberOfElementsThatNeedToBeRecalculated);

        // populate table
        response.data.forEach((element) => {
          this.dailyLogs.push(element);
        });

        if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
          this.launchPaja();
        }
      });
    },

    calculateStartedYesterdayTime(element) {
      if (element.didIstartedYesterday) {
        return (
          maskIfEquealsValue(
            new Date(element.arrivalTimeGeneral).toLocaleTimeString(
              "sr-latn-cs"
            ),
            "01:00:00"
          ) + (this.dotOrArrow ? "." : "⬅️")
        );
      } else {
        return maskIfEquealsValue(
          new Date(element.arrivalTimeGeneral).toLocaleTimeString("sr-latn-cs"),
          "01:00:00"
        );
      }
    },

    calculateStayesTillTomorrowTime(element) {
      if (element.didIstayedTillTomorrow) {
        return (
          "➡️" +
          maskIfEquealsValue(
            new Date(element.departureTimeGeneral).toLocaleTimeString(
              "sr-latn-cs"
            ),
            "01:00:00"
          )
        );
      } else {
        return maskIfEquealsValue(
          new Date(element.departureTimeGeneral).toLocaleTimeString(
            "sr-latn-cs"
          ),
          "01:00:00"
        );
      }
    },
  },
};
</script>

<style scoped>
/* Component-specific styles */
.month-badge {
  background: rgba(255, 255, 255, 0.15);
}

/* Legacy support */
.cmitem {
  width: 150px;
  border: none;
  background-color: inherit;
  padding: 14px 28px;
  font-size: 12px;
  cursor: pointer;
  display: inline-block;
}

.cmitem:hover {
  background: #c3ffeb;
}

.ev-inactive-employee-option {
  color: #9ca3af;
}
</style>
